import { Component } from '@angular/core';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css']
})
export class AgreementComponent {
english:boolean=true;
hindi:boolean=false;
ngOnInit(): void {
  const storeVal = localStorage.getItem('selectedValue');
  if (storeVal == 'english') {
    this.english = true;
    this.hindi = false;
  }
  if (storeVal == 'hindi') {

    this.english = false;
    this.hindi = true;
  }

}
}
